<template>
    <div>
        <div class="pagetitle">
            <h1>Area</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Home</li>
                    <li class="breadcrumb-item">Forms</li>
                    <li class="breadcrumb-item active">Area</li>
                </ol>
            </nav>
        </div>
        <div class="col text-left">
            <a href="#" class="btn btn-sm btn-primary shadow-sm" data-toggle="modal" data-target="#tambahArea">
                <i class="bi bi-plus fa-sm text-white-50"></i> Tambah Area
            </a>
        </div> <br>
        <div class="row mb-3">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Area</h5>
                        <div>
                            <label for="searchQuery" class="form-label">Search:</label>
                            <input type="text" v-model="searchQuery" @change="fetchAreas" class="form-control mb-3" />
                            <div class="form-group mb-3">
                                <label for="pageSize" class="form-label">Items per page:</label>
                                <select id="pageSize" v-model="pageSize" @change="fetchAreas" class="form-select">
                                <option v-for="size in [1, 5, 10, 15, 20, 100]" :key="size" :value="size">
                                    {{ size }}
                                </option>
                                </select>
                            </div>
                            <table class="table table-striped table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">No</th>
                                        <th scope="col">Area</th>
                                        <th scope="col">Jumlah Titik</th>
                                        <th scope="col">Language</th>
                                        <th scope="col">Status</th>
                                        <th scope="col" style="text-align:center">Opsi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(area, index) in filteredAreas" :key="area.id">
                                        <td>{{ index + 1 + (currentPage - 1) * pageSize }}</td>
                                        <td>{{ area.name_area }}</td>
                                        <td>{{ area.titik_area }}</td>
                                        <td>{{ area.language == 'id' ? '🇮🇩 Indonesia' : '🇬🇧 English' }}</td>
                                        <td>
                                            <span v-if="area.status == '1'" class="badge bg-success">Active</span>
                                            <span v-else class="badge bg-danger">Inactive</span>
                                        </td>
                                        <td style="text-align:center">
                                            <a href="#" class="btn btn-sm btn-outline-primary shadow-sm" style="margin-right: 5px" @click="showModal('detail', area.id)">
                                                <i class="bi bi-eye fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-danger shadow-sm" style="margin-right: 5px" @click="deleteArea(area.id)">
                                                <i class="bi bi-trash fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-warning shadow-sm" style="margin-right: 5px" @click="showModal('edit', area.id)">
                                                <i class="bi bi-pencil-square fa-sm text-dark"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul class="pagination justify-content-center" @change="fetchAreas">
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                                    </li>
                                    <li v-if="showStartEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li
                                        class="page-item"
                                        v-for="page in displayedPages"
                                        :key="page"
                                        :class="{ active: currentPage === page }"
                                    >
                                        <button class="page-link" @click="changePage(page)">{{ page }}</button>
                                    </li>
                                    <li v-if="showEndEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === pages }">
                                        <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === pages">Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Tambah -->
        <div class="modal fade" id="tambahArea" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tambahSuratModalLabel">Area Forms</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="addArea">
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="ID" placeholder="ID" v-model="area.created_by" readonly>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="nama" placeholder="nama" v-model="area.created_by_name" readonly>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="floatingName" placeholder="Area" v-model="area.name_area">
                                    <label for="floatingName">Area</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="number" class="form-control" id="floatingName" placeholder="Jumlah Titik Area" v-model="area.titik_area">
                                    <label for="floatingName">Jumlah Titik</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="language" id="status" v-model="area.language">
                                        <option value="id">🇮🇩 Indonesia</option>
                                        <option value="en">🇬🇧 English</option>
                                    </select>
                                    <label for="language">Bahasa</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="status" id="status" v-model="area.status">
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                    <label for="status">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Submit</button> ||
                                <button type="button" class="btn btn-secondary" @click="resetForm">Reset</button>
                            </div>
                        </form><!-- End floating Labels Form -->
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Detail  -->
        <div ref="detailAreaModal" class="modal fade" id="detailArea" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="detailAreaModalLabel">Detail Area</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="nama_Area">Area</label>
                                        <input type="text" class="form-control" id="nama_Area" placeholder="Nama Area" v-model="area.name_area" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="nama_Area">Jumlah Area</label>
                                        <input type="text" class="form-control" id="nama_Area" placeholder="Nama Area" v-model="area.titik_area" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="pembuat_nama">Nama Pembuat</label>
                                        <input type="text" class="form-control" id="pembuat_nama" placeholder="Nama Pembuat" v-model="area.created_by_name" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="language">Bahasa</label>
                                        <input type="text" class="form-control" id="language" placeholder="Bahasa" :value="area.language === 'id' ? '🇮🇩 Indonesia' : '🇬🇧 English'" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="status">Status</label>
                                        <select class="form-control" name="status" id="status" v-model="area.status" disabled>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button class="btn btn-secondary" @click="closeModal"> Close </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Edit -->
        <div class="modal fade" id="editArea" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="editAreaModalLabel">Edit Area</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="updateArea">
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="updated_by" placeholder="ID" v-model="selectedArea.updated_by" readonly/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="updated_by_name" placeholder="Nama PEmbuat" v-model="selectedArea.updated_by_name" readonly/>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="floatingName" placeholder="ID" v-model="area.id" readonly/>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="floatingName" placeholder="Nama Area" v-model="area.name_area"/>
                                    <label for="floatingName">Nama Area</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="number" class="form-control" id="floatingName" placeholder="Nama Area" v-model="area.titik_area"/>
                                    <label for="floatingName">Titik Area</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="language" id="status" v-model="area.language">
                                        <option value="id">🇮🇩 Indonesia</option>
                                        <option value="en">🇬🇧 English</option>
                                    </select>
                                    <label for="language">Bahasa</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                <select class="form-select" name="status" id="status" v-model="area.status">
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                                <label for="is_active">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import areajs from './jsArea/area';
export default areajs;
</script>